<template>
  <div>
    <h1>Main Panel {{env}}</h1>
    <v-btn @click="loadUsers">Load Users</v-btn>
  </div>
</template>

<script>

import {mapState} from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'


  export default {
    name: 'MainPanel',
    computed: {
      ...mapState({
        env: (state) => state.env,
      }),
    },
    data() {
      return {
      }
    },
    components: {

    },
    mounted: function() {

    },
    methods: {
      'loadUsers' : async function () {

        // console.log("Length:"+allUsers.users.length)
        let currentUser = firebase.auth().currentUser
        console.log("CUR USER IS: "+currentUser)
      }

    }
  }
</script>
